import React, { useEffect, useState } from 'react';
import { Box, Dialog, Grid2, IconButton, TextField, Typography } from '@mui/material';
import CustomButton from '../button/CustomButton';
import CustomRadioButton from '../button/CustomRadioButton';
import CustomDataGrid from '../dataTable/CustomDataGrid';
import { CloseRoundedIcon, CustomConfirmDialog, CustomToggleButton, EditCalendarIcon, GridColDef, GridRenderCellParams, Toaster, useApi, validationMessages } from '../../utils/globalImports';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { InputAdornment, Button, Divider } from '@mui/material';

interface TPL {
  id: number | null;
  subStageID: number;
  tplName: string;
  email: string;
  status: string;
}


interface TPLModalProps {
  open: boolean;
  onClose: () => void;
  subStageId: number | null;
}

enum state {
  "Active" = 1,
  "Inactive" = 0,

}

const CustomTPLModal: React.FC<TPLModalProps> = ({
  open,
  onClose,
  subStageId,
}) => {

  const { execute } = useApi();
  const [initialTPLRows, setinitialTPLRows] = useState<TPL[] | null>([]);
  const [SnackBarOpen, setSnackBarOpen] = useState<boolean | null>(false);
  const [selectedSubStageId, setSelectedSubStageId] = useState<number | null>();
  const [toast, setToast] = useState({ open: false, message: "", type: "success" });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [formData, setFormData] = useState<TPL>({
    id: null,
    subStageID: 0,
    tplName: "",
    email: "",
    status: "Active"
  });

  const fetchTPL = async () => {
    const { data } = await execute<TPL[]>(
      'get',
      'Proposal/SubStageTPL',
      {
        SubStageId: subStageId
      }
    )
    const formattedData = (data || []).map(item => ({
      ...item,
      status: Number(item.status) == 1 ? "Active" : "Inactive"
    }));
    setinitialTPLRows(formattedData);
  }

  useEffect(() => {
    fetchTPL();
  }, [])
  const colors = [
    { subColor: "#eef2ff", color: "#3949ab" },
    { subColor: "#e6f4ea", color: "#2e7d32" },
    { subColor: "#e3f2fd", color: "#1565c0" },
    { subColor: "#fff3e0", color: "#ef6c00" },
    { subColor: "#ede7f6", color: "#5e35b1" },
    { subColor: "#fce4ec", color: "#c2185b" },
    { subColor: "#f7dbdb", color: "#e70b12" },
  ];
  const sampleTPLColumns: GridColDef[] = [
    {
      field: "tplName", headerName: "Name", flex: 1, headerAlign: "center",
      renderCell: (params: GridRenderCellParams<TPL>) => {
        const color = colors[Math.floor(Math.random() * 7) + 0];
        return (
          <>

            <Box sx={{
              height: "29px", width: "29px", mr: 1, borderRadius: "50%",
              backgroundColor: color.subColor,
              color: color.color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight:"600",
            }}>
              {params.value.substring(0, 1).toUpperCase()}
            </Box>
            {params.value}</>
        );
      }
    },
    { field: "email", headerName: "Email", flex: 1, headerAlign: "center", },
    {
      field: "status", headerName: "Status", flex: 1, headerAlign: "center",
      renderCell: (params: GridRenderCellParams<TPL>) => {
        return (
          <>
            <Button
              disabled
              variant="outlined"
              sx={{
                width: "100px",
                '&.Mui-disabled': {
                  color: params.value === "Active" ? "rgba(150, 193, 33, 0.75)" : "grey",
                  borderColor: params.value === "Active" ? "rgba(150, 193, 33, 0.75)" : "grey",
                  backgroundColor: params.value === "Active" ? "rgba(248, 255, 229, 0.75)" : "#F5F5F5",
                },
                height:"35px"
              }}
            >
              <Typography variant='h4'>•</Typography> {params.value}
            </Button>
          </>
        );
      }
    },
    {
      field: "actions",
      headerName: "Action",
      flex: 1,
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams<TPL>) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            width: "100%",
          }}
        >
          <IconButton
            color="primary"
            aria-label="edit"
            onClick={() => {
              handleEdit(params.row);
            }}
          >
            <EditCalendarIcon sx={{ color: "#a3c63d" }} />
          </IconButton>

          <CustomToggleButton
            isOn={params.row.status === "Active"}
            onClick={() => { handleEdit(params.row); setConfirmOpen(true); }}
          />
        </div>
      ),
    },
  ];

  const handleEdit = (row: TPL) => {
    setSelectedEditId(row.id);
    setSelectedRow(row);
    setFormData({
      id: row.id,
      subStageID: row.subStageID,
      tplName: row.tplName,
      email: row.email,
      status: row.status,
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleToggleState = (row: any) => {
    if (row.status === 0) {
      setIsOn(true)
    } else {
      setIsOn(false)
    }
  }
  //useStates
  const [selectedEditId, setSelectedEditId] = useState<number | null>(null);
  const [isOn, setIsOn] = useState<boolean>();
  const [selectedRow, setSelectedRow] = useState<any | null>(null)

  const AlreadyExist = (Email: string) => {
    return initialTPLRows?.some(tpl => tpl.email.toLowerCase() === Email.toLowerCase() && tpl.id !== formData.id);
  }

  const handleSubmit = async (isStatusUpdate: boolean = false) => {
    try {
      if (formData.tplName.trim().length <= 0 || formData.email.trim().length <= 0) {
        setToast({
          open: true,
          message: "Name and Email is required",
          type: "error"
        });
        return;
      }
      if (AlreadyExist(formData.email)) {
        setToast({
          open: true,
          message: "A TPL with this email already exists",
          type: "error"
        });
        return;
      }
      if (!isValidEmail(formData.email)) {
        setToast({
          open: true,
          message: "Please enter a valid email address",
          type: "error"
        });
        return;
      }
      const payload = {
        id: (formData.id != null && formData.id > 0) ? formData.id : null,
        subStageID: subStageId,
        tplName: formData.tplName,
        email: formData.email,
        //status: isStatusUpdate ? (formData.status === "Active" ? 0 : 1) : (formData.status === "Active" ? 1 : 0)
        status: isStatusUpdate
          ? Number(formData.status !== "Active")
          : Number(formData.status === "Active")
      }
      const { data } = await execute<boolean>(
        'post',
        'Proposal/SubStageTPL',
        payload
      )
      if (data === true) {
        setToast({
          open: true,
          message:
            formData.id == null
              ? "Added Successfully"
              : "Updated Successfully",
          type: "success"
        });
        setConfirmOpen(false);
        oncancel();
        fetchTPL();
        open = false;
      } else {
        setToast({
          open: true,
          message: "Operation failed",
          type: "error"
        });
      }

    }
    catch (error) {

    }
    finally {

    }
  }
  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  const oncancel = () => {
    setSelectedEditId(null);
    setSelectedRow(null);
    setSelectedSubStageId(null);
    setFormData({
      id: null,
      subStageID: 0,
      tplName: "",
      email: "",
      status: "Active"
    })
  }
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          height: '80vh',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '12px',
        },
      }}
    >
      {/* ── Header ── */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', px: 3, pt: 3, pb: 1 }}>
        <Box
          sx={{
            width: 44, height: 44, borderRadius: '50%',
            backgroundColor: '#e8f5e9',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            mr: 1.5, flexShrink: 0,
          }}
        >
          <GroupsIcon sx={{ color: '#66bb6a', fontSize: 24 }} />
        </Box>
        <Box>
          <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#1a1a1a' }}>
            Manage TPL
          </Typography>
          <Typography sx={{ fontSize: '12px', color: '#888', mt: 0.2 }}>
            Add and manage Third Party Logistics (TPL) contacts.
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          sx={{
            ml: 'auto',
            color: '#aaa',
            '&:hover': { color: '#555' },
          }}
        >
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </Box>

      <Divider />

      {/* ── Inline Form ── */}
      <Box sx={{ px: 3, py: 2 }}>
        <Grid2 container spacing={2} alignItems="flex-end">
          <Grid2 size={4}>
            <Typography sx={{ fontSize: '12px', fontWeight: 600, mb: 0.5 }}>
              Name <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Enter TPL name"
              name="tplName"
              value={formData.tplName}
              onChange={handleChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonOutlineIcon sx={{ fontSize: 18, color: '#a3c63d' }} />
                  </InputAdornment>
                ),
                sx: { borderRadius: "8px" },
              }}
            />
          </Grid2>

          <Grid2 size={4}>
            <Typography sx={{ fontSize: '12px', fontWeight: 600, mb: 0.5 }}>
              Email <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Enter Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlinedIcon sx={{ fontSize: 18, color: '#a3c63d',mr: 0 }} />
                  </InputAdornment>
                ),
                sx: { borderRadius: "8px" },
              }}
            />
          </Grid2>

          {(formData.id != null && formData.id > 0) && (
            <Grid2 size={12} display="flex">
              <CustomRadioButton
                label="Active" value="Active" name="status"
                checked={formData.status === "Active"} onChange={handleChange}
              />
              <CustomRadioButton
                label="Inactive" value="Inactive" name="status"
                checked={formData.status === "Inactive"} onChange={handleChange}
              />
            </Grid2>
          )}

          <Grid2>
            <CustomButton
              onClick={() => { handleSubmit() }}
              sx={{
                backgroundColor: '#8bc34a',
                '&:hover': { backgroundColor: '#7cb342' },
                borderRadius: '8px',
                px: 2.5,
                height: '40px',
              }}
            >
              {selectedEditId ? 'Update' : '+ Add TPL'}
            </CustomButton>
          </Grid2>

          {selectedEditId && (
            <Grid2>
              <CustomButton
                backgroundColor="#1e66ab"
                hoverColor="rgba(150,193,33,0.75)"
                onClick={oncancel}
              >
                Cancel
              </CustomButton>
            </Grid2>
          )}
        </Grid2>
      </Box>

      <Divider />

      {/* ── TPL List Header ── */}
      <Box sx={{ px: 3, pt: 2, pb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#1a1a1a' }}>
          TPL List
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* <TextField
            size="small"
            placeholder="Search by name or email..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 18, color: '#aaa' }} />
                </InputAdornment>
              ),
              sx: { borderRadius: '8px', fontSize: '13px', backgroundColor: '#fafafa' },
            }}
            sx={{ width: 240 }}
            onChange={(e) => {filter}}
          /> */}
          {/* <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            endIcon={<ArrowDropDownIcon />}
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              color: '#555',
              borderColor: '#ddd',
              fontSize: '13px',
              '&:hover': { borderColor: '#bbb', backgroundColor: '#f5f5f5' },
            }}
          >
            Filter
          </Button> */}
        </Box>
      </Box>

      {/* ── Data Grid ── */}
      <Box sx={{ flex: 1, overflow: 'auto', px: 2, pb: 2 }}>
        <CustomDataGrid
          rows={initialTPLRows}
          columns={sampleTPLColumns}
          isToggleOn={isOn}
        />
      </Box>

      <Toaster
        open={toast.open}
        message={toast.message}
        type={toast.type as "success" | "error"}
        onClose={() => setToast({ ...toast, open: false })}
      />
      <CustomConfirmDialog
        open={confirmOpen}
        title={formData.status === "Active" ? "Deactivate TPL" : "Activate TPL"}
        message={validationMessages.SubFeeStage_Confirm(
          formData.status === "Active" ? "Inactive" : "Active"
        )}
        onConfirm={() => handleSubmit(true)}
        onCancel={() => setConfirmOpen(false)}
        onClose={() => setConfirmOpen(false)}
      />
    </Dialog>
  );
};

export default CustomTPLModal;
